import React from "react";
import styles from "./style.module.css";
import taskStyles from "./taskStyles.module.css";
import moment from "moment";

import { Popover, OverlayTrigger } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagic,
  faExclamationTriangle,
  faTrash,
  faComment,
  faHourglass,
  faCalendar
} from "@fortawesome/free-solid-svg-icons";
import { Button, TileTitle, TileSubtitle, Tile, TileBody, TileItem, Icon } from "aible";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import Thumbtack from "images/Thumbtack.svg";
import FullPin from "images/Next-Icons/FullPin.svg";
import FirstVarIcon from "images/Next-Icons/drill-in-2.svg";
import SecondVarIcon from "images/Next-Icons/drill-in-1.svg";
import TelescopeIcon from "images/Next-Icons/mode-voting.svg";
import StatAssocIcon from "images/Next-Icons/stats.svg";
import PopularIcon from "images/Next-Icons/mode-voting.svg";
import VotingIcon from "images/Next-Icons/model-voting.svg";
import TrainIcon from "images/Next-Icons/TrainIcon.svg";
import PPTDownloadIcon from "images/Next-Icons/PPTDownloadIcon.svg";
import ReviewDeployIcon from "images/Next-Icons/ReviewDeployIcon.svg";
import AibleIcon from "images/Next-Icons/AibleIcon.png";

import IntegrateIcon from "images/Next-Icons/IntegrateIcon.svg";
import MonitorSettingsIcon from "images/Next-Icons/MonitorSettingsIcon.svg";

import PredictIcon from "images/Next-Icons/PredictIcon.svg";
import BusinessIcon from "images/Next-Icons/BusinessIcon.svg";
import FairnessIcon from "images/Next-Icons/FairnessIcon.svg";
import ResourceIcon from "images/Next-Icons/ResourceIcon.svg";
import RocketIcon from "images/Next-Icons/RocketIcon.svg";

import MagnifierIcon from "images/Next-Icons/MagnifierIcon.svg";
import HexIconBackground from "images/Next-Icons/HexIconBackground.svg";
import CheckmarkIcon from "images/Next-Icons/CheckmarkIcon.svg";
import PurpleBlueprintIcon from "images/Next-Icons/PurpleBlueprintIcon.svg";
import PurpleCompassIcon from "images/Next-Icons/PurpleCompassIcon.svg";
import FunnelIcon from "images/Next-Icons/FunnelIcon.svg";
import CashIcon from "images/Next-Icons/CashIcon.svg";
import HeartLifelineIcon from "images/Next-Icons/HeartLifelineIcon.svg";
import StethoscopeIcon from "images/Next-Icons/StethoscopeIcon.svg";
import LabVialIcon from "images/Next-Icons/LabVialIcon.svg";
import SecurityCheckIcon from "images/Next-Icons/SecurityCheckIcon.svg";
import WaypointIcon from "images/Next-Icons/WaypointIcon.svg";
import BullseyeIcon from "images/Next-Icons/BullseyeIcon.svg";
import MiniFunnelIcon from "images/Next-Icons/MiniFunnelIcon.svg";
import NewMoneyIcon from "images/Next-Icons/NewMoneyIcon.svg";
import FairnessScalesIcon from "images/Next-Icons/FairnessScalesIcon.svg";
import ExpertIcon from "images/Next-Icons/ExpertIcon.svg";
import ResumeIcon from "images/Next-Icons/ResumeIcon.svg";
import MicroscopeIcon from "images/Next-Icons/MicroscopeIcon.svg";
import ReturnIcon from "images/Next-Icons/ReturnIcon.svg";
import GearsIcon from "images/Next-Icons/GearsIcon.svg";
import ChartIcon from "images/Next-Icons/ChartIcon.svg";
import SpreadsheetIcon from "images/Next-Icons/SpreadsheetIcon.svg";
import ScalesIconWhiteBackground from "images/Next-Icons/ScalesIconWhiteBackground.svg";
import TodoAssignIcon from "images/Next-Icons/TodoAssignIcon.svg";
import TodoFeedbackIcon from "images/Next-Icons/TodoFeedbackIcon.svg";
import TodoPinIcon from "images/Next-Icons/TodoPinIcon.svg";
import TodoAddIcon from "images/Next-Icons/TodoAddIcon.svg";
import TodoXIcon from "images/Next-Icons/TodoXIcon.svg";

import LayersWhiteImg from "aible/images/layers-white.svg";

import { readableSearch } from "containers/Next/Models/ModelsReducer";

export default class TasksTile extends React.PureComponent {
  handleDelete(event) {
    event.stopPropagation();
    const { handleDelete, onHover } = this.props;

    if (handleDelete) {
      onHover && onHover(undefined);
      return handleDelete(event);
    } else return;
  }

  renderTask() {
    const { data, onClick, handleDelete, userId } = this.props;

    const hasComment = data.comment_count > 0;

    const status =
      data?.status === "ACCEPTED"
        ? "Approved"
        : data?.status === "REJECTED"
          ? "Rejected"
          : (data?.versions && data?.versions.length > 0) || (hasComment && data?.type === "EVAL_MODEL_DRIVERS")
            ? "Pending"
            : "Not Started";

    const canDelete = userId === data?.created_by?.id;

    return (
      <div className={taskStyles.senseTile}>
        <div className={taskStyles.tileHeader} onClick={onClick}>
          <div className={taskStyles.tFlex}>
            <div style={{ width: "100%" }}>
              <div className={taskStyles.tileHeaderLarge}>
                <img src={LayersWhiteImg} style={{ marginRight: "5px" }} />
                {data?.project?.name || data?.name}
              </div>
            </div>
          </div>
          {canDelete && (
            <div className={taskStyles.headerActionBox}>
              <div className={taskStyles.headerButton}></div>
              <div className={taskStyles.headerButton}>
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDelete();
                  }}
                  style={{ padding: "6px" }}
                  type={"transparent"}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              </div>
            </div>
          )}
        </div>
        <div className={taskStyles.tileBody}>
          <div className={taskStyles.senseSection}>
            <div className={taskStyles.senseAll}>
              <div
                className={taskStyles.openOverview}
                style={{
                  width: "100%",
                  zIndex: 55
                }}
              >
                {"Task: " + data?.name}
              </div>
              <div
                className={taskStyles.openOverview}
                style={{
                  width: "100%",
                  zIndex: 55
                }}
              >
                <div className={taskStyles.tBold}>
                  <img src={TodoFeedbackIcon} style={{ marginRight: "5px" }} />
                  {"Comment"}
                </div>
                <div className={taskStyles.tSub}>{data?.description}</div>
              </div>
              <div
                className={taskStyles.openOverview}
                style={{
                  width: "100%",
                  zIndex: 55
                }}
              >
                <div className={taskStyles.tSub}>
                  <FontAwesomeIcon icon={faHourglass} className={taskStyles.tIcon} />
                  {status}
                </div>
                <div
                  className={taskStyles.tSub}
                  title={moment.utc(data?.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
                >
                  <FontAwesomeIcon icon={faCalendar} className={taskStyles.tIcon} />
                  {"Assigned " + moment(data?.created_date).utc(data?.created_date).local().fromNow()}
                </div>
                <div className={taskStyles.tSub}>
                  <img src={TodoAssignIcon} className={taskStyles.tIcon} />
                  {"Assigned By: " + data?.created_by?.fullname}
                </div>
                <div className={taskStyles.tSub}>
                  <img src={TodoAssignIcon} className={taskStyles.tIcon} />
                  {"Assigned To: " + data?.assigned_to?.fullname}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { data, handleDelete, onClick } = this.props;

    return this.renderTask();

    const status =
      data?.status === "ACCEPTED"
        ? "Approved"
        : data?.status === "REJECTED"
          ? "Rejected"
          : data?.versions && data?.versions.length > 0
            ? "In Progress"
            : "Not Started";

    return (
      <div className={styles.taskTileWrapping}>
        <Tile
          onClick={onClick}
          buttonText={"Open Task"}
          handleDelete={handleDelete ? (e) => this.handleDelete(e) : undefined}
          style={{ height: "280px", width: "280px" }}
        >
          <TileTitle
            title={data?.project?.title || data?.name}
            color={"#512f77"}
            icon={"projectSegments"}
            style={{ color: "white" }}
            iconDiv={
              <img
                style={{ transform: "scale(0.75)" }}
                src={
                  data?.type === "DEPLOY_REVIEW"
                    ? ReviewDeployIcon
                    : data?.type === "DEPLOY_INTEGRATION"
                      ? IntegrateIcon
                      : data?.type === "DEPLOY_MONITOR"
                        ? MonitorSettingsIcon
                        : data?.type === "OPTIMIZE_STRATEGY"
                          ? BullseyeIcon
                          : data?.type === "OPTIMIZE_TRANSACTION"
                            ? MiniFunnelIcon
                            : data?.type === "OPTIMIZE_COSTS"
                              ? NewMoneyIcon
                              : data?.type === "OPTIMIZE_BLUEPRINT"
                                ? WaypointIcon
                                : data?.type === "PREDICT_WHAT_IF"
                                  ? StethoscopeIcon
                                  : data?.type === "DEPLOY_REVIEW"
                                    ? LabVialIcon
                                    : data?.type === "FAIR_GUIDE"
                                      ? ScalesIconWhiteBackground
                                      : data?.type === "FAIR_VALUE"
                                        ? SecurityCheckIcon
                                        : data?.type === "BUDGET_SUBGROUP"
                                          ? MicroscopeIcon
                                          : data?.type === "BUDGET_RETRAIN"
                                            ? ReturnIcon
                                            : data?.type === "EVAL_MODEL_DRIVERS"
                                              ? GearsIcon
                                              : data?.type === "REVIEW_MODEL_METRICS"
                                                ? SpreadsheetIcon
                                                : data?.type === "REVIEW_MODEL_CHARTS"
                                                  ? ChartIcon
                                                  : null
                }
              />
            }
          >
            {data?.project?.name || data?.name}
          </TileTitle>
          <TileBody>
            <div className={styles.nBody}>{data?.description}</div>
            <TileItem icon={"user"}>{status}</TileItem>
            <TileItem icon={"dataset"}>{data?.project?.name}</TileItem>
            {data.created_date ? (
              <TileItem
                icon={"calendar"}
                overlay={moment.utc(data.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
              >
                {moment.utc(data.created_date).local().fromNow()}
              </TileItem>
            ) : (
              ""
            )}
            {data.created_by ? (
              <TileItem icon={"user"}>
                {data.created_by.fullname !== undefined ? data.created_by.fullname : data.created_by}
              </TileItem>
            ) : (
              ""
            )}
          </TileBody>
        </Tile>
      </div>
    );
  }
}
